"use client";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { TfiAngleLeft, TfiAngleRight } from "react-icons/tfi";

export default function page() {
  const [galaryImages, setGalaryImages] = useState([]);
  const [bannerImage, setBannerImage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const itemsPerPage = 12;

  useEffect(() => {
    const fetchGalaryImages = async () => {
      try {
        const response = await fetch("/api/web-content");

        if (response.ok) {
          const data = await response.json();
          setGalaryImages(data.gallery?.images || []);
          setBannerImage(data.gallery?.banner);
        }
      } catch (error) {
        console.error("Failed to fetch Gallery:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchGalaryImages();
  }, []);

  useEffect(() => {
    if (galaryImages.length > 0) {
      NativeFancybox.bind('[data-fancybox="gallery"]', {
        Thumbs: {
          autoStart: true,
        },
        Toolbar: {
          display: [
            "zoom",
            "slideshow",
            "fullscreen",
            "download",
            "thumbs",
            "close",
          ],
        },
      });
    }

    return () => {
      NativeFancybox.destroy();
    };
  }, [galaryImages, currentPage]);

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentImages = galaryImages.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(galaryImages.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "80vh", width: "100%" }}
      >
        <div
          className="spinner-border"
          role="status"
          style={{
            color: "var(--theme-color, #F55B1F)",
            width: "3rem",
            height: "3rem",
          }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className="breadcrumb-wrapper bg-cover"
        style={{
          backgroundImage: `url("/assets/img/banners/gallery_bg_new.webp")`,
        }}
      >
        <div className="shape-image float-bob-y"></div>
        <div className="container">
          <div className="breadcrumb-wrapper-items">
            <div className="page-heading">
              <div className="breadcrumb-sub-title">
                <h1 className="wow fadeInUp" data-wow-delay=".3s">
                  Gallery
                </h1>
              </div>
              <ul
                className="breadcrumb-items wow fadeInUp"
                data-wow-delay=".5s"
              >
                <li>
                  <Link href={`/`}> Home </Link>
                </li>
                <li>
                  <i className="fa-sharp fa-solid fa-slash-forward" />
                </li>
                <li>Gallery</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="container py-5">
        <div className="row">
          {currentImages.length > 0 ? (
            currentImages.map((item, index) => (
              <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
                <div className="card mb-4">
                  <div className="card-body p-0">
                    <div className="mt-0">
                      <div className="service-thumb">
                        <Link
                          href={item}
                          data-fancybox="gallery"
                          data-caption={"Gallery Image"}
                        >
                          <img
                            src={item}
                            width={346}
                            height={350}
                            alt={"Gallery Image"}
                            className="rounded"
                            style={{
                              width: "100%",
                              height: "350px",
                              objectFit: "cover",
                            }}
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center text-white">No images available</div>
          )}
        </div>

        {/* Pagination Controls */}
        {totalPages >= 1 && (
          <div className="row">
            <div className="col-lg-12">
              <nav aria-label="Page navigation example">
                <ul className="pagination justify-content-center">
                  {/* Previous Button */}
                  <li
                    className={`page-item ${currentPage === 1 ? "disabled" : "bg-green"}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      aria-label="Previous"
                    >
                      <span aria-hidden="true">
                        <TfiAngleLeft />
                      </span>
                    </button>
                  </li>

                  {/* Page Numbers */}
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                    (number) => (
                      <li
                        key={number}
                        className={`page-item ${currentPage === number ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(number)}
                          style={{
                            height: "30px",
                            lineHeight: "18px",
                          }}
                        >
                          {number}
                        </button>
                      </li>
                    ),
                  )}

                  {/* Next Button */}
                  <li
                    className={`page-item ${currentPage === totalPages ? "disabled" : "bg-green"}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      aria-label="Next"
                    >
                      <span aria-hidden="true">
                        <TfiAngleRight />
                      </span>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
